import { Building2, FileCheck, FlaskConical, Heart, ShieldCheck } from 'lucide-react';

// ============================================================
// TrustStrip — selos resumidos abaixo do hero (preview da §8)
// ============================================================

const items = [
  { icon: ShieldCheck, label: 'LGPD' },
  { icon: FileCheck, label: 'CFM 2.314/22' },
  { icon: Building2, label: 'SUS-ready' },
  { icon: FlaskConical, label: 'CEP-CONEP' },
  { icon: Heart, label: 'Aprovado por autistas' },
];

export function TrustStrip() {
  return (
    <div className="lume-trust" aria-label="Pilares de conformidade do Lume">
      <div
        className="lume-container"
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 'clamp(1rem, 4vw, 2.5rem)',
        }}
      >
        {items.map(({ icon: Icon, label }) => (
          <span key={label} className="lume-trust__item">
            <Icon size={16} aria-hidden="true" />
            {label}
          </span>
        ))}
      </div>
    </div>
  );
}
